// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2cKRV","footer":"ChangeClinic_footer__3gTvY"};